import React from 'react';
import { LoginComponent } from '@app/Login/LoginComponent';
import { LoginResponse } from '@app/utils/utils';

interface LoginProps {
  setToken: (data: LoginResponse) => void;
}

export default function Login({ setToken }: LoginProps) {
  return <LoginComponent triggerRefresh={setToken} />;
}
